import axios from 'axios';
import { baseDomain } from '@/common/config'
import { service } from '@/utils/request.js'

// ============ 舞种管理 ============
const Api = {
  Dance_Page: baseDomain + '/dance/page', // 舞种分页
  Dance_Detail: baseDomain + '/dance/', // 舞种详情
  Dance_Create: baseDomain + '/dance/create', // 新建舞种
  Dance_Update: baseDomain + '/dance/update', // 编辑舞种
  Dance_Delete: baseDomain + '/dance/', // 删除舞种
  Dance_Export: baseDomain + '/dance/export', // 导出舞种列表

  Deploy_Dance: baseDomain + '/deploy/dance', // 执行舞种下发
  Deploy_Precheck: baseDomain + '/deploy/precheck', // 设备预检
}

// ============ 舞种管理 API ============

// 舞种分页
export const reqDancePage = (params) => {
  return service({
    url: Api.Dance_Page,
    method: 'POST',
    data: params
  })
}

// 舞种详情
export const reqDanceDetail = (id) => {
  return service({
    url: Api.Dance_Detail + id,
    method: 'GET',
  })
}

// 新建舞种
export const reqDanceCreate = (params) => {
  return service({
    url: Api.Dance_Create,
    method: 'POST',
    data: params
  })
}

// 编辑舞种
export const reqDanceUpdate = (params) => {
  return service({
    url: Api.Dance_Update,
    method: 'PUT',
    data: params
  })
}

// 删除舞种
export const reqDanceDelete = (id) => {
  return service({
    url: Api.Dance_Delete + id,
    method: 'DELETE',
  })
}

// 导出舞种列表
export const reqDanceExport = (params) => {
  return service({
    url: Api.Dance_Export,
    method: 'POST',
    data: params,
    responseType: 'blob',
  })
}

// 执行舞种下发
export const reqDeployDance = (params) => {
  return service({
    url: Api.Deploy_Dance,
    method: 'POST',
    data: params
  })
}

// 设备预检
export const reqDeployPrecheck = (params) => {
  return service({
    url: Api.Deploy_Precheck,
    method: 'POST',
    data: params
  })
}
